import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { PrFormService } from '@app/components/pr-form/pr-form.service';
import { LoanDao } from '@app/dao/loan/loan.dao';
import { UserDao } from '@app/dao/user/user.dao';
import { neutralizeLoanPaliers } from '@app/services/loan/loan-palier.form';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest, Subject } from 'rxjs';
import { EaEstateLoanFormService } from './ea-estate-loan-form.service';

@UntilDestroy()
@Component({
  selector: 'ea-estate-loan-form',
  templateUrl: './ea-estate-loan-form.component.html',
  styleUrls: ['./ea-estate-loan-form.component.scss'],
  standalone: false,
})
export class EaEstateLoanFormComponent
  extends PrFormAbstract
  implements OnInit
{
  users: any[];
  countries: any[] = [];
  personalUseType: any[] = [];
  subscriptionSource: any[] = [];
  doneSubject: Subject<void> = new Subject<void>();
  loanCategories: any;

  constructor(
    protected formConstructor: PrFormConstructor,
    private userDao: UserDao,
    private loanDao: LoanDao,
    private eaEstateLoanFormService: EaEstateLoanFormService,
  ) {
    super(formConstructor);
    this.eaEstateLoanFormService.generateSubject.subscribe(
      formGroup => (this.form = formGroup),
    );
  }

  ngOnInit() {
    if (!this.form.controls) this.initForm(this.entity);
    this.watchPaliersAvailability();
    combineLatest([
      this.userDao.getCouple(),
      this.loanDao.getReferences(),
    ]).subscribe(([users, references]) => {
      const itemsToRemove = ['AUTO', 'STUDENT', 'CONSO', 'INVESTMENT'];
      this.users = users;
      this.loanCategories = references.categories.filter(
        item => !itemsToRemove.includes(item.id),
      );

      // Défaut : titulaire principal à 100 % si aucun détenteur n'est encore saisi.
      const ownersControl = this.form?.get('owners');
      if (ownersControl && !(ownersControl.value || []).length) {
        const mainId = this.extractMainOwnerId();
        if (mainId != null) {
          ownersControl.setValue([{ ownerId: mainId, share: 1 }]);
        }
      }
    });
  }

  get isPaliersAvailable(): boolean {
    return (
      this.form?.get('hasLoan')?.value === true &&
      this.form?.get('knowTotal')?.value === true
    );
  }

  get hasPaliers(): boolean {
    return this.form?.get('paliersEnabled')?.value === true;
  }

  private watchPaliersAvailability(): void {
    this.form
      ?.get('paliersEnabled')
      ?.valueChanges.pipe(untilDestroyed(this))
      .subscribe(enabled => {
        if (enabled === true) this.form.get('knowTotal')?.setValue(true);
      });

    ['hasLoan', 'knowTotal'].forEach(name =>
      this.form
        ?.get(name)
        ?.valueChanges.pipe(untilDestroyed(this))
        .subscribe(() => {
          if (!this.isPaliersAvailable) neutralizeLoanPaliers(this.form);
        }),
    );
  }

  private extractMainOwnerId(): number | null {
    const main =
      this.users?.find((u: any) => u.relation === 'MAIN' || u.isMain) ||
      this.users?.[0];
    return main?.id ?? null;
  }

  public generate = () => this.eaEstateLoanFormService.generate(this.entity);
  public extract = () => this.eaEstateLoanFormService.extract(this.form);
  onSubmit() {}
}
